<footer class="pie-pagina">
    <div class="grupo-1">
        <div class="box logo">
            <figure>
                    <img src="../../../../../../assets/img/Logo_speakup.png" width="50px"  class="rounded mt-3">
            </figure>
            <div class="d-flex justify-content-center px-3 text-white text-center my-3">
              <span>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus dolore alias nobis distinctio reiciendis non tenetur neque
              </span>
            </div>
            <div class="d-block d-sm-none px-3 text-white text-center my-4 border-top">
              
              <p>
                Services
              </p>
              <p>
                Web development
              </p>
              <p>
                UI/UX design
              </p>
              <p>
                Branding design
              </p>
            </div>
            <div class="box redes-sociales d-flex justify-content-center my-3">
              <div class="red-social ">
                  <a href="#" class="fab icon-redes fa-facebook"></a>
                  <a href="#" class=" fab icon-redes fa-instagram"></a>
                  <a href="#" class=" fab icon-redes fa-twitter"></a>
                  <a href="#" class=" fab icon-redes fa-linkedin"></a>
                  <a href="#" class=" fab icon-redes fa-youtube-square"></a>
              </div>
          </div>
        </div>
        <div class="row d-none d-md-block  w-100" >
            <div class="col-md-12 d-flex justify-content-center ">
              <div class="row">
                <div class="col-4">
                  <!-- <h2 class="siguenos text-light">Sobre nosotros</h2> -->
                  <ul>
                    <li><a href="#" class=" links-footer"> About as</a>  </li>
                    <li><a href="#" class=" links-footer"> Missión </a></li>
                    <li><a href="#" class=" links-footer"> Our team </a></li>
                    <li><a href="#" class=" links-footer"> testimonials </a></li>
                    <li><a href="#" class=" links-footer"> Privacy policy </a></li>
                  </ul>
                </div>
                <div class="col-4"> 
                  <!-- <h2 class="siguenos text-light">Asistencia</h2> -->
                  <ul>
                    <li><a href="#"  class=" links-footer"> Services</a></li>
                    <li><a href="#"  class=" links-footer">Web design</a> </li>
                    <li><a href="#"  class=" links-footer">Web development</a> </li>
                    <li><a href="#"  class=" links-footer">UI/UX design</a> </li>
                    <li><a href="#"  class=" links-footer">Branding design</a> </li>
                  </ul>
                </div>
                <div class="col-4"> 
                  <!-- <h2 class="siguenos text-light">Asistencia</h2> -->
                  <ul>
                    <li><a href="#"  class=" links-footer"> Contact us</a></li>
                    <li><a href="#"  class=" links-footer">Inforatión</a> </li>
                    <li><a href="#"  class=" links-footer">Consultatión</a> </li>
                    <li><a href="#"  class=" links-footer">Help center</a> </li>
                    <li><a href="#"  class=" links-footer">Term and conditions</a> </li>
                  </ul>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="grupo-2">
        <small>&copy; {{fecha}} <b>{{empresa}}</b> - Todos los Derechos Reservados.</small>
    </div>
</footer>
